import { render } from "./Culture.vue?vue&type=template&id=06505f7d&scoped=true"
import script from "./Culture.vue?vue&type=script&lang=js"
export * from "./Culture.vue?vue&type=script&lang=js"

import "@/assets/css/layout.css?vue&type=style&index=0&id=06505f7d&scoped=true&lang=css"
import "@/assets/css/culture.css?vue&type=style&index=1&id=06505f7d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\info\\Documents\\ownersite.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06505f7d"]])

export default __exports__